import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledRestartTrialDunningsSitewideBanner = styled(Flex)`
    background: ${colorsPalettes.indigo[300]};
    padding: 8px 16px;
    gap: 16px;
    justify-content: center;
    align-items: center;
    height: 48px;
    ${setElevation("Z2")};
`;
